import { store, observable, persist, action } from '~/common/mobx.decorator'

import { SELF_MODE_SCOPE, SELF_MODE_SWITCHED_KEY } from './self-mode.constants'

export * from './self-mode.constants'

// Time for mobx-persist to write the new value and for the "Switching…" screen
// to paint before the reload throws the page away.
const RELOAD_DELAY_MS = 300

@store({ persist: true, persistKey: 'maestro-self-mode' })
class SelfModeStore {
	@persist @observable enabled = false
	@persist @observable ownerId = null
	/** The scope being switched to while the page reloads; drives the "Switching…" screen. */
	@observable switching = null

	@action
	setScope = (scope, profileId) => {
		const enabled = scope === SELF_MODE_SCOPE.mine
		this.enabled = enabled
		this.ownerId = enabled ? profileId ?? null : null
		this.switching = scope

		try {
			window.sessionStorage.setItem(SELF_MODE_SWITCHED_KEY, scope)
		} catch (e) {
			// Private mode / blocked storage: the switch still works, it just goes unannounced.
		}

		setTimeout(() => window.location.reload(), RELOAD_DELAY_MS)
	}
}

export const selfModeStore = new SelfModeStore()
